var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from 'inversify';
import { LocalStorage } from '../../local-storage';
import { AppError } from '../../error';
let TranslationLocaleService = class TranslationLocaleService {
    constructor(localStorage) {
        this.localStorage = localStorage;
        this.key = 'language';
        this.defaultLanguage = 'ru';
        this.supportedLanguages = ['ru'];
    }
    get() {
        const lang = this.localStorage.getItem(this.key);
        if (!lang || !this.supportedLanguages.includes(lang)) {
            return this.defaultLanguage;
        }
        return lang;
    }
    save(lang) {
        if (!this.supportedLanguages.includes(lang)) {
            throw new AppError('client', {
                code: 400,
                message: 'Нет поддержки данного языка',
            });
        }
        this.localStorage.setItem(this.key, lang);
    }
};
TranslationLocaleService = __decorate([
    injectable(),
    __param(0, inject(LocalStorage)),
    __metadata("design:paramtypes", [Object])
], TranslationLocaleService);
export { TranslationLocaleService };
